import React from 'react'
import {FaCheckCircle, FaExclamationCircle} from 'react-icons/fa'
import Notice from '@components/V3/Notice'
import Text from '@components/V3/Text'
import isCompleted from '@page-components/TrackV2/helpers/isCompleted'
import useStatus from '@page-components/TrackV2/hooks/useStatus'
import {useTranslation} from 'next-i18next'

import useOrderDetails from '../useOrderDetails.main'

export default function NoTransaction() {
  const order = useOrderDetails()
  const status = useStatus()
  const {t} = useTranslation('tracking', {keyPrefix: 'order.inner.transaction.noTransaction'})
  const completed = isCompleted(status)

  return (
    <Notice level={completed ? 'success' : 'warning'} className="mb-8">
      <div className="flex gap-4 items-center">
        {completed ? <FaCheckCircle size={24} /> : <FaExclamationCircle size={24} />}
        <div className="flex flex-col">
          <Text type="body" className={completed ? '!text-green-600' : '!text-yellow-600'}>
            {completed ? t('completed') : t('pending')}
          </Text>
          <Text type="caption" className="!text-gray-800">
            {t('paymentMethod', {paymentMethod: order.paymentMethodLabel})}
          </Text>
        </div>
      </div>
    </Notice>
  )

  return null
}
